module.exports = __webpack_public_path__ + "img/icon-notification.dfbd8659.svg";